export default "__VITE_ASSET__B7jpjMmi__"